import { HCPFlowEnum } from './hcp-flow.interface'

/** Fluxos com colunas cadastráveis pelo gerenciador do Kanban. */
const FLOWS_WITH_MANAGEABLE_COLUMNS = new Set<string>([
  HCPFlowEnum.SHEET,
  HCPFlowEnum.PRODUCTION,
  HCPFlowEnum.MACHINE_PRODUCTION,
  HCPFlowEnum.LOGISTICS,
])

export function canManageFlowColumns(flow: HCPFlowEnum): boolean {
  return FLOWS_WITH_MANAGEABLE_COLUMNS.has(flow)
}
